import BackendResponse from '@core/shared/backend-response';
import { HttpGetRequest } from '@infrastructure/axios/http-get-request';
import { ContractCellFix, IGetContractCellFix } from '../../interfaces/contract-cell-fix';

export default class GetContractCellFix extends HttpGetRequest<ContractCellFix[]> implements IGetContractCellFix {
  public async execute(): Promise<BackendResponse<ContractCellFix[]>> {
    const url = this.buildURL('/contracts/cell-fix').get();
    return (await this.dispatch(url)).data;
  }
}
